import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell
} from 'recharts';

export default function SeasonalityChart({ data }) {
  // Use AI-provided seasonality data or generate from available info
  const seasonality = data || {};

  const monthlyData = seasonality.monthly || [
    { month: 'Jan', reviews: 0 }, { month: 'Feb', reviews: 0 },
    { month: 'Mar', reviews: 0 }, { month: 'Apr', reviews: 0 },
    { month: 'May', reviews: 0 }, { month: 'Jun', reviews: 0 },
    { month: 'Jul', reviews: 0 }, { month: 'Aug', reviews: 0 },
    { month: 'Sep', reviews: 0 }, { month: 'Oct', reviews: 0 },
    { month: 'Nov', reviews: 0 }, { month: 'Dec', reviews: 0 },
  ];

  const peakTimes = seasonality.peakTimes || [];
  const slowTimes = seasonality.slowTimes || [];
  const insights = seasonality.insights || [];

  const hasData = monthlyData.some(m => m.reviews > 0) || peakTimes.length > 0 || insights.length > 0;

  if (!hasData && !seasonality.overview) {
    return (
      <div className="card p-6">
        <h3 className="font-display text-lg text-white mb-1">Seasonality & Timing Intel</h3>
        <p className="text-neutral-600 text-sm mt-2">Run AI Audit with Google Reviews to populate seasonality patterns.</p>
      </div>
    );
  }

  return (
    <div className="card p-6">
      <h3 className="font-display text-lg text-white mb-1">Seasonality & Timing Intel</h3>
      <p className="text-xs text-neutral-500 mb-5">When are guests visiting and when are issues highest?</p>

      {/* Overview */}
      {seasonality.overview && (
        <div className="bg-neutral-800/40 rounded-lg p-4 mb-5">
          <p className="text-sm text-neutral-300">{seasonality.overview}</p>
        </div>
      )}

      {/* Peak and slow times */}
      {(peakTimes.length > 0 || slowTimes.length > 0) && (
        <div className="grid sm:grid-cols-2 gap-4 mb-5">
          {peakTimes.length > 0 && (
            <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-lg p-3">
              <p className="text-xs text-emerald-400 font-semibold mb-1.5">Peak Times</p>
              {peakTimes.map((t, i) => <p key={i} className="text-xs text-neutral-400 mb-0.5">{typeof t === 'string' ? t : JSON.stringify(t)}</p>)}
            </div>
          )}
          {slowTimes.length > 0 && (
            <div className="bg-amber-500/5 border border-amber-500/20 rounded-lg p-3">
              <p className="text-xs text-amber-400 font-semibold mb-1.5">Slow Periods</p>
              {slowTimes.map((t, i) => <p key={i} className="text-xs text-neutral-400 mb-0.5">{typeof t === 'string' ? t : JSON.stringify(t)}</p>)}
            </div>
          )}
        </div>
      )}

      {/* Monthly chart */}
      {monthlyData.some(m => m.reviews > 0) && (
        <div>
          <p className="text-xs text-neutral-500 font-medium mb-3">Monthly Review Volume</p>
          <div style={{ height: 200 }}>
            <ResponsiveContainer>
              <BarChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
                <XAxis dataKey="month" tick={{ fill: '#a3a3a3', fontSize: 10 }} />
                <YAxis tick={{ fill: '#525252', fontSize: 10 }} />
                <Tooltip contentStyle={{ backgroundColor: '#171717', border: '1px solid #333', borderRadius: 8, fontSize: 12 }} />
                <Bar dataKey="reviews" fill="#C9A668" radius={[3, 3, 0, 0]} opacity={0.7} name="Reviews" />
                {monthlyData[0]?.complaints !== undefined && (
                  <Bar dataKey="complaints" fill="#f87171" radius={[3, 3, 0, 0]} opacity={0.8} name="Complaints" />
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* Insights */}
      {insights.length > 0 && (
        <div className="mt-4 space-y-2">
          {insights.map((insight, i) => (
            <div key={i} className="bg-neutral-800/30 rounded-lg p-3">
              <p className="text-xs text-neutral-400"><span className="text-brand-gold font-semibold">Insight:</span> {typeof insight === 'string' ? insight : JSON.stringify(insight)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
